import { Injectable, Inject } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { timeout, retry, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class Kevlar2Service {
    private apiUrl = `${environment.apiHost}/meraki`;

    constructor(private http: HttpClient, @Inject(OKTA_AUTH) public oktaAuth: OktaAuth) {
    }

    async getAvailableKevlar2Indexes(storeNumber: string) {
        return this.http.get(`${this.apiUrl}/kevlar2/indexes?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken(),
                    "Cache-Control": "max-age=0" }
                )
            }).pipe(
                timeout(10000),
                retry(1),
                catchError(error => of("Request for indexes timed out!"))
            );
    }

    async getAvailableKevlar2IndexesWithStatus(storeNumber: string) {
        return this.http.get(`${this.apiUrl}/kevlar2/indexes-with-status?storeNumber=${storeNumber}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken(),
                    "Cache-Control": "max-age=0" }
                )
            }).pipe(
                timeout(10000),
                retry(1),
                catchError(error => of("Request for indexes timed out!"))
            );
    }

    async getKevlar2Index(storeNumber: string, timestamp: number) {
        return this.http.get(`${this.apiUrl}/kevlar2/index?storeNumber=${storeNumber}&timestamp=${timestamp}`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(1),
                catchError(error => of("Request for index timed out!"))
            );
    }

    async createKevlar2Index(storeNumber: string) {
        return this.http.post(`${this.apiUrl}/kevlar2/index`,
            {
                "storeNumber": storeNumber
            },
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(30000),
                retry(0),
                catchError(error => of("Post request for index timed out!"))
            );
    }

}